import { render, staticRenderFns } from "./MPopupFrame.vue?vue&type=template&id=e7efd42c&"
import script from "./MPopupFrame.ts?vue&type=script&lang=ts&"
export * from "./MPopupFrame.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports